export const projectScheduleImportTranslationsEn = {
  onboardingStepperTitle: 'Import project',
  onboardingStepperDescription: 'Upload your existing schedule',
  importInProgress: 'Schedule import in progress...',
  importSuccess: 'Schedule import successful',
  importSuccessDescription: 'Please refresh the page to get started!',
  importFailed: 'Schedule import failed',
  startImport: 'Import schedule',
  selectPlan: 'Select plan',
  fakes: {
    importProgressStep1: 'File is being read...',
    importProgressStep2: 'Phases and domains are being identified...',
    importProgressStep3: 'Construction site setup is being generated...',
    importProgressStep4: 'Shell construction is being generated...',
    importProgressStep5: 'Building envelope is being generated...',
    importProgressStep6: 'Fitout is being generated...',
    importProgressStep7: 'Other is being generated...',
    importProgressStep8: 'Milestones are being assigned...',
    importProgressStep9: 'Dependencies are being added...',
    importProgressStep10: 'Import is being completed...',
    importSuccessHint: 'Note:',
    importSuccessHint1:
      'The lines and activities were automatically generated and may differ from the original structure',
    importSuccessHint2:
      'Activities that could not be assigned to any of the generated lines were summarized in a "Other" line',
    importSuccessHint3: 'The trades of the activities were automatically determined',
    importSuccessHint4: 'Break and working times were not transferred',
  },
};
